import { createContext } from 'react';

export type IMultiSession = {
  sessionId: string;
  isCurrent?: boolean;
};

export type IMultiSessionsContextValue = {
  currentId?: string;
  add: (multiSession: IMultiSession) => void;
};

const stub = (): never => {
  throw new Error(
    'You forgot to wrap your component in <MultiSessionsContext.Provider />.',
  );
};

export const MultiSessionsContext = createContext<IMultiSessionsContextValue>({
  currentId: undefined,
  add: stub,
});
